export type { TestimonialCarouselProps } from '~/features/testimonials/components/testimonial-carousel';
export { TestimonialCarousel } from '~/features/testimonials/components/testimonial-carousel';
